var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.867 17.5C16.867 16.337 16.867 15.7555 16.7235 15.2824C16.4003 14.217 15.5666 13.3834 14.5013 13.0602C14.0281 12.9167 13.4467 12.9167 12.2837 12.9167H8.11703C6.95406 12.9167 6.37257 12.9167 5.89941 13.0602C4.83407 13.3834 4.00039 14.217 3.67722 15.2824C3.53369 15.7555 3.53369 16.337 3.53369 17.5M13.9504 6.25C13.9504 8.32107 12.2714 10 10.2004 10C8.12929 10 6.45036 8.32107 6.45036 6.25C6.45036 4.17893 8.12929 2.5 10.2004 2.5C12.2714 2.5 13.9504 4.17893 13.9504 6.25Z",
    stroke: "#F7F8F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatUserIcon);
export default __webpack_public_path__ + "static/media/cat-user-icon.d2a0f0326daed149186f15ef055a6929.svg";
export { ForwardRef as ReactComponent };